import React from 'react';
import './DragContainer.scss';

const DragContainer = ({ children }) => {
  return <div id="video-recording-drag-container">{children}</div>;
};

export default DragContainer;
